import { useLayoutEffect } from 'react';

export const useLockBodyScroll = (lockScroll: boolean) => {
  useLayoutEffect(() => {
    if (lockScroll) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  }, [lockScroll]);
};
